// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__1wiGF","icons":"Sidebar_icons__+fyYt"};